interface ILogin{
    email: string,
    password: string
}

export const instanceOfILogin = (object: any) : object is ILogin => {
    return 'email' in object &&
            'password' in object
}

export default ILogin